import { Controller } from "stimulus"

export default class extends Controller
  initialize: ->
    $(@element).find('[data-toggle-target]').each (index, element) =>
      new App.Views.ToggleTargetView el: element